"use strict";

exports.__esModule = true;
exports.compareThresholds = compareThresholds;
/**
 * Compare two thresholds by value, useful when sorting.
 */
function compareThresholds(a, b) {
  var av = a[0];
  var bv = b[0];
  if (av < bv) {
    return -1;
  }
  if (av > bv) {
    return 1;
  }
  return 0;
}